import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='financial-planning'
      backgroundVariant='darkDefault'
      headingText={<>Now you&#39;re ready to take the next step toward your <WidowBlock>financial plan.</WidowBlock></>}
      text={<>No matter where you&#39;re starting from, your advisor will show you a better way to money to help you have a better life.</>}
      subText={<>It&#39;s easy to get started&#8212;no commitment, just a better conversation.</>}
      linkAriaLabel='Start planning with a financial advisor'
    />
  );
};
